import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

export default {
  namespaced: true,
  state: {
    formData: {
      addressInformation: null,
      userAccountSetup: null,
    },
    userIdentity: null,
    userLocationIdentity: null,
  },
  getters,
  mutations,
  actions,
};
